import React from "react";
import PropTypes from "prop-types";

import BulkUploadForm, {
  TemplateHelperText,
} from "../../../../../forms/BulkUploadForm";

export { Anchor } from "../../../../../forms/BulkUploadForm";

const TEMPLATE_ROWS = [
  "order,description,for_po,for_rfq",
  "0,Payment due within 30 days,1,0",
  "1,Delivery scheduled 48h in advance,1,1",
  "2,RFQ responses valid for 60 days,0,1",
];

export const HelperText = () => (
  <TemplateHelperText
    rows={TEMPLATE_ROWS}
    fileName="Bulk Terms Template.csv"
    linkText="Download Terms Template"
  />
);

const TermsBulkUpload = ({
  onSubmit,
  loading,
  pluralEntity,
  file,
  errorMessage,
}) => (
  <BulkUploadForm
    onSubmit={onSubmit}
    loading={loading}
    pluralEntity={pluralEntity}
    file={file}
    errorMessage={errorMessage}
    helperText={<HelperText />}
  />
);

TermsBulkUpload.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  pluralEntity: PropTypes.string.isRequired,
  file: PropTypes.shape({}),
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default TermsBulkUpload;
